import { ITableFields } from 'contentful-types'
import { withContentful } from 'src/siteBuilder/renderer/contentful/withContentful'
import { BlockRenderer } from 'src/siteBuilder/renderer/contentful/BlockRenderer'
import Table, { type TableProps } from './Table'
import { typedLowerCase } from '@/siteBuilder/utils/text/mappers'

const ContentfulTable = withContentful<ITableFields, TableProps>(Table, {
  header: (props) => ({
    cells: props.fields.header.fields.cells?.map((cell) => ({
      content: cell.fields.content?.map((content, i) => {
        return <BlockRenderer key={`header-cell-${i}`} block={content} />
      }),
      cellAlign: typedLowerCase(cell.fields.horizontalAlign),
    })),
    rowCellAlign: typedLowerCase(props.fields.header.fields.rowCellAlign),
  }),
  body: (props) =>
    props.fields.body.map((row) => ({
      cells: row.fields.cells.map((cell) => ({
        content: cell.fields.content.map((content, i) => <BlockRenderer key={`body-cell-${i}`} block={content} />),
        cellAlign: typedLowerCase(cell.fields.horizontalAlign),
      })),
      rowCellAlign: typedLowerCase(row.fields.rowCellAlign),
    })),
})

export default ContentfulTable
